import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { fetchFtmInfo } from "../service";
import MarkAsApproved from "./MarkAsApproved";
import LoadingSpinner from "./LoadingSpinner";
import CardTemplate from "./template/CardTemplate";
import { theme } from "../../../theme";

const PersonalDetails = ({isHistory = false}) => {
    const { ftm_id } = useParams();
    const [loading, setLoading] = useState(true);
    const [info, setInfo] = useState([]);
    const [cardHeight, setCardHeight] = useState(null);

    // Fetch data
    useEffect(() => {
        const getFtmInfo = async () => {
            try {
                setLoading(true);
                const response = await fetchFtmInfo(ftm_id);
                if (response?.status === "Success" && Array.isArray(response?.info)) {
                    setInfo(response.info);
                } else {
                    setInfo([]);
                }
            } catch (error) {
                console.error("🚀 ~ getFtmInfo ~ error:", error);
                setInfo([]);
            } finally {
                setLoading(false);
            }
        };

        getFtmInfo();
    }, [ftm_id]);

    const firstCol = info.slice(0, 3);
    const secondCol = info.slice(3);

    const InfoCard = ({ section, isRemoveBottom }) => (
        <li
            className={`list-group-item border-0 d-flex flex-column flex-fill p-4 ${isRemoveBottom ? "" : "mb-4"} bg-gray-300 border-radius-lg`}
            style={{ minHeight: "230px" }}
        >
            <h6 className="mb-3 text-sm">{section.title}</h6>
            {section.details?.map((d, idx) => (
                <span key={idx} className="mb-2 font-weight-bold text-xs">
                    {d.name}:{" "}
                    <span className="text-dark font-weight-bold ms-sm-2">
                        {d.value || "N/A"}
                    </span>
                </span>
            ))}
        </li>
    );

    return (
        <CardTemplate
            title="Personal Details"
            isHistory={isHistory}
            children={
                <>
                    {loading ? (
                        <LoadingSpinner loading={loading} cardHeight={cardHeight} setCardHeight={setCardHeight} />
                    ) : (
                        <>
                            {!isHistory ? (
                                <div className="row">
                                    {[firstCol, secondCol].map((col, colIdx) => (
                                        <div
                                            className={`col-12 col-lg-${isHistory ? "12" : "6"} d-flex flex-column mb-4`}
                                            key={colIdx}
                                        >
                                            <ul className="list-group d-flex flex-column h-100">
                                                {col.map((section, i) => (
                                                    <InfoCard
                                                        key={i}
                                                        section={section}
                                                        isRemoveBottom={i === col.length - 1}
                                                    />
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <>
                                    {info.map((section, idx) => (
                                        <div className="card card-plain h-100 px-3" key={idx} style={{marginBottom: '15px'}}>
                                            <div className="card-header pb-0 p-0">
                                                <div className="row">
                                                    <div className="col-md-12 d-flex align-items-center">
                                                        <h6 className={`mb-0 text-${theme.main}`}>{section.title}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-body p-0">
                                                <ul className="list-group">
                                                    {section.details.map((d, i) => (
                                                        <li className="list-group-item border-0 ps-0 py-1 text-xs" key={i}>
                                                            <strong className="text-dark">{d.name}:</strong> &nbsp; {d.value || "N/A"}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </>
                    )}

                    {!isHistory && <MarkAsApproved approvalProcessKey="ALL_PERSONAL_DETAILS_APPROVED" isShowFtmEdit={true} />}
                </>
            }
        />
    );
};

export default PersonalDetails;